import { useState, useEffect } from 'react';

const useDataFormModal = (delay = 10000) => { // default 3 seconds
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const checkAndShowModal = () => {
      const formSubmitted = localStorage.getItem('formSubmitted');
      const submissionTime = localStorage.getItem('formSubmissionTime');
      
      // If form was never submitted or it's been more than 24 hours since last submission
      if (!formSubmitted || (submissionTime && 
          new Date().getTime() - new Date(submissionTime).getTime() > 24 * 60 * 60 * 1000)) {
        
        const timer = setTimeout(() => {
          setIsModalOpen(true);
        }, delay);

        return () => clearTimeout(timer);
      }
    };

    checkAndShowModal();
  }, [delay]);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return {
    isModalOpen,
    closeModal
  };
};

export default useDataFormModal; 